import React from "react";
import { Upload } from "antd";
import { DeleteIcon, DragIcon } from "assets/icons";
import "./style.scss";
import Button from "components/BaseWidgets/button";

const { Dragger } = Upload;

function DraggerComponent({ fileList, setFileList }) {
  const props = {
    name: "file",
    multiple: false,
    fileList,
    beforeUpload: () => false,
    onChange(info) {
      setFileList([...info.fileList]);
    },
    onDrop(e) {
      const droppedFiles = Array.from(e.dataTransfer.files).map(
        (file, idx) => ({
          uid: `${Date.now()}-${idx}`,
          name: file.name,
          status: "done",
          originFileObj: file,
        }),
      );
      setFileList(droppedFiles);
    },
    showUploadList: {
      showRemoveIcon: true,
      showDownloadIcon: false,
    },
    itemRender: (originNode, file, currFileList, actions) => {
      return (
        <div className="custom-upload-item" key={file.uid}>
          <div className="file-info">
            <span className="file-name">{file.name}</span>
          </div>

          <Button
            type="button"
            className="custom-remove-btn"
            onClick={() => actions.remove()}
            aria-label={`Remove ${file.name}`}
          >
            <DeleteIcon />
          </Button>
        </div>
      );
    },
  };

  return (
    <Dragger {...props} className="dragger-component">
      <p className="ant-upload-drag-icon">
        <DragIcon />
      </p>
      <p className="ant-upload-text">Drag and drop file here or browse</p>
      <p className="ant-upload-hint">Supported file formats: JPG, PNG, JPEG</p>
    </Dragger>
  );
}

export default DraggerComponent;
